/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { JaegerExporter } from './jaeger';
export type { ExporterConfig } from './types';
